/** Keep in sync with cookie key read in `app/views/companies/shared/_sidebar.html.erb`. */
const SIDEBAR_COLLAPSED_COOKIE_KEY = 'app_navigation_collapsed';

function persistSidebarCollapsedCookie(collapsed) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const maxAgeOneYearSeconds = 60 * 60 * 24 * 365;
  const secureFlag = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${SIDEBAR_COLLAPSED_COOKIE_KEY}=${String(collapsed)}; path=/; max-age=${maxAgeOneYearSeconds}; SameSite=Lax${secureFlag}`;
}

function readSidebarCollapsedCookie() {
  if (typeof document === 'undefined') return false;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${SIDEBAR_COLLAPSED_COOKIE_KEY}=([^;]+)`));
  return match ? match[1] === 'true' : false;
}

/** Returns true for pages where an expanded sidebar causes layout issues. */
function shouldForceSidebarCollapsed(pathname) {
  if (!pathname) return false;
  // Course Authoring edit page - force collapsed regardless of cookie
  return /\/course_authoring\/trainings\/\d+\/edit\/?(\?|#|$)/.test(pathname);
}

export {
  persistSidebarCollapsedCookie,
  readSidebarCollapsedCookie,
  shouldForceSidebarCollapsed,
};
